<h2 mat-dialog-title style="font-weight: normal; padding: 1.5rem 1.5rem 0px 1.5rem">
	<span *ngIf="!data.isEditQuote" fxFlex>Tell Us About Your Next Load</span>
	<span *ngIf="data.isEditQuote" fxFlex>Update Quote Details</span>
	<span fxFlex fxLayoutAlign="end end">
		<mat-icon (click)="closeDialog(null)" class="primary-light-color" style="cursor: pointer"
			>close</mat-icon
		>
	</span>
</h2>
<mat-divider></mat-divider>

<mat-dialog-content style="padding: 1.5rem 1.5rem 0rem 1.5rem; margin: 1px">
	<app-load-details-template
		(loadCreated)="closeDialog($event)"
		[isDuplicateLoad]="data.isDuplicateLoad"
		[isEditQuote]="data.isEditQuote"
		[load]="data.data"
		[quote]="data.quote"
		postLoad="true"
	>
	</app-load-details-template>
</mat-dialog-content>
